import { GithubOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React, { useState, useEffect } from 'react';
import { getPublicSettings, onSettingsUpdated } from '@/utils/systemSettings';

const Footer: React.FC = () => {
  const [settings, setSettings] = useState({
    contactEmail: 'admin@chaxin.com',
    contactPhone: '0571-12345678',
  });

  useEffect(() => {
    // 加载初始设置
    getPublicSettings().then((publicSettings) => {
      setSettings({
        contactEmail: publicSettings.contactEmail || 'admin@chaxin.com',
        contactPhone: publicSettings.contactPhone || '0571-12345678',
      });
    });

    // 监听设置更新
    const cleanup = onSettingsUpdated((newSettings) => {
      setSettings({
        contactEmail: newSettings.contactEmail,
        contactPhone: newSettings.contactPhone,
      });
    });

    return cleanup;
  }, []);

  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="查新服务系统 - 专业的科技查新和查收查引服务平台"
      links={[
        {
          key: 'email',
          title: (
            <span>
              <MailOutlined /> {settings.contactEmail}
            </span>
          ),
          href: `mailto:${settings.contactEmail}`,
          blankTarget: false,
        },
        {
          key: 'phone',
          title: (
            <span>
              <PhoneOutlined /> {settings.contactPhone}
            </span>
          ),
          href: `tel:${settings.contactPhone}`,
          blankTarget: false,
        },
      ]}
    />
  );
};

export default Footer;
